import React from 'react';
export default class IframeComponent extends React.Component {
  render() {
    return (
      <div style= { {height:'94%', width: '100%'}}>
        <iframe src={this.props.src} height={this.props.height} width={this.props.width} style= { {border:'none'}} className="fullheight"/>
      </div>
    )
  }
}